import React from "react";

const DEFAULT_LABELS = {
  online: "Online",
  text: "Message our manager on Telegram right now",
  ariaLabel: "Message our manager on Telegram",
};

const SIZE_TOKENS = {
  nav: {
    avatar: 48,
    dot: 12,
    fontSize: 13,
    lineHeight: 1.35,
    onlineFontSize: 10.5,
    gap: 12,
    padding: "6px 10px 6px 6px",
  },
  footer: {
    avatar: 56,
    dot: 14,
    fontSize: 14,
    lineHeight: 1.4,
    onlineFontSize: 11,
    gap: 14,
    padding: "8px 14px 8px 8px",
  },
};

const THEME_TOKENS = {
  light: {
    text: "var(--ink)",
    subtle: "var(--fg-muted)",
    ring: "rgba(255,255,255,0.9)",
    hoverBg: "rgba(2, 42, 45, 0.04)",
    onlinePillBg: "rgba(46, 204, 113, 0.14)",
    onlinePillText: "#1e8449",
  },
  dark: {
    text: "var(--white)",
    subtle: "rgba(255,255,255,0.75)",
    ring: "rgba(255,255,255,0.35)",
    hoverBg: "rgba(255,255,255,0.06)",
    onlinePillBg: "rgba(46, 204, 113, 0.18)",
    onlinePillText: "#2ecc71",
  },
};

const ONLINE_DOT = "#2ecc71";

export const ContactManager = ({
  size = "nav",
  theme = "light",
  telegramUrl = "https://t.me/snesterenko7",
  photoSrc = "/manager.jpg",
  labels = DEFAULT_LABELS,
  className = "",
}) => {
  const s = SIZE_TOKENS[size] || SIZE_TOKENS.nav;
  const c = THEME_TOKENS[theme] || THEME_TOKENS.light;
  const testId = `contact-manager-${size}`;

  return (
    <a
      href={telegramUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={labels.ariaLabel}
      data-testid={testId}
      data-size={size}
      className={`contact-manager cm-${size} ${className}`}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: s.gap,
        padding: s.padding,
        borderRadius: 999,
        textDecoration: "none",
        color: c.text,
        minHeight: 44,
        minWidth: 44,
        transition:
          "transform 0.28s cubic-bezier(0.22,0.61,0.36,1), background 0.28s cubic-bezier(0.22,0.61,0.36,1), opacity 0.28s",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = c.hoverBg;
        e.currentTarget.style.transform = "translateY(-1px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "transparent";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <span
        style={{
          position: "relative",
          display: "inline-block",
          width: s.avatar,
          height: s.avatar,
          flex: "none",
        }}
      >
        <img
          src={photoSrc}
          alt=""
          width={s.avatar}
          height={s.avatar}
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            objectFit: "cover",
            display: "block",
            boxShadow: "0 2px 8px rgba(2, 42, 45, 0.18)",
            outline: `2px solid ${c.ring}`,
            outlineOffset: "-1px",
          }}
        />
        <span
          aria-hidden="true"
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            width: s.dot,
            height: s.dot,
            borderRadius: "50%",
            background: ONLINE_DOT,
            border: `2px solid ${theme === "dark" ? "var(--bg-inverse, #0b2a2e)" : "var(--white, #fff)"}`,
            boxShadow: `0 0 0 0 rgba(46, 204, 113, 0.6)`,
            animation: "cm-pulse 1.6s cubic-bezier(0.22,0.61,0.36,1) infinite",
          }}
        />
      </span>

      <span
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 3,
          minWidth: 0,
        }}
      >
        <span
          data-testid={`${testId}-online`}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            padding: "2px 9px",
            borderRadius: 999,
            background: c.onlinePillBg,
            color: c.onlinePillText,
            fontFamily: "'Open Sans', var(--font-body), sans-serif",
            fontSize: s.onlineFontSize,
            fontWeight: 700,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            lineHeight: 1,
          }}
        >
          <span
            aria-hidden="true"
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: ONLINE_DOT,
              display: "inline-block",
            }}
          />
          {labels.online}
        </span>
        <span
          data-testid={`${testId}-text`}
          className="contact-manager-text"
          style={{
            fontFamily: "'Open Sans', var(--font-body), sans-serif",
            fontSize: s.fontSize,
            fontWeight: 500,
            lineHeight: s.lineHeight,
            color: c.text,
            maxWidth: 240,
          }}
        >
          {labels.text}
        </span>
      </span>
    </a>
  );
};
